import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FaBars, FaTimes, FaChevronDown, FaPhone, FaEnvelope } from 'react-icons/fa';
import './Navbar.css';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [activeDropdown, setActiveDropdown] = useState(null);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsOpen(false);
    setActiveDropdown(null);
  }, [location]);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const handleDropdown = (dropdown) => {
    setActiveDropdown(activeDropdown === dropdown ? null : dropdown);
  };

  return (
    <>
      <div className="top-bar">
        <div className="container">
          <div className="top-bar-content">
            <div className="top-bar-left">
              <span><FaPhone /> +91 9896251565</span>
              <span><FaEnvelope /> info@nnbsportsclub.com</span>
            </div>
            <div className="top-bar-right">
              <span>Mon - Sat: 6:00 AM - 10:00 PM</span>
            </div>
          </div>
        </div>
      </div>

      <nav className={`navbar ${scrolled ? 'scrolled' : ''}`}>
        <div className="container">
          <div className="nav-content">
            <Link to="/" className="logo">
              <div className='set'>
                <img src="/img/logo.png" alt="logo" />
              </div>
            </Link>

            <div className={`nav-menu ${isOpen ? 'active' : ''}`}>
              <ul className="nav-links">
                <li>
                  <Link to="/" className={location.pathname === '/' ? 'active' : ''}>
                    Home
                  </Link>
                </li>

                <li className="dropdown">
                  <button
                    className={`dropdown-toggle ${['/about', '/history', '/mission-vision', '/why-choose-us'].includes(location.pathname) ? 'active' : ''}`}
                    onClick={() => handleDropdown('about')}
                  >
                    About <FaChevronDown className={activeDropdown === 'about' ? 'rotate' : ''} />
                  </button>
                  <ul className={`dropdown-menu ${activeDropdown === 'about' ? 'show' : ''}`}>
                    <li><Link to="/about">About Us</Link></li>
                    <li><Link to="/history">Our History</Link></li>
                    <li><Link to="/mission-vision">Mission & Vision</Link></li>
                    <li><Link to="/why-choose-us">Why Choose Us</Link></li>
                  </ul>
                </li>

                <li className="dropdown">
                  <button
                    className={`dropdown-toggle ${['/services', '/court-rental', '/training', '/membership'].includes(location.pathname) ? 'active' : ''}`}
                    onClick={() => handleDropdown('services')}
                  >
                    Services <FaChevronDown className={activeDropdown === 'services' ? 'rotate' : ''} />
                  </button>
                  <ul className={`dropdown-menu ${activeDropdown === 'services' ? 'show' : ''}`}>
                    <li><Link to="/services">All Services</Link></li>
                    <li><Link to="/court-rental">Court Rental</Link></li>
                    <li><Link to="/training">Training Programs</Link></li>
                    <li><Link to="/membership">Membership</Link></li>
                  </ul>
                </li>
                <li>
                  <Link to="/testimonials" className={location.pathname === '/testimonials' ? 'active' : ''}>
                    Testimonials
                  </Link>
                </li>

                <li className="dropdown">
                  <button
                    className={`dropdown-toggle ${['/blog', '/events'].includes(location.pathname) || location.pathname.startsWith('/blog/') ? 'active' : ''}`}
                    onClick={() => handleDropdown('blog')}
                  >
                    Blog <FaChevronDown className={activeDropdown === 'blog' ? 'rotate' : ''} />
                  </button>
                  <ul className={`dropdown-menu ${activeDropdown === 'blog' ? 'show' : ''}`}>
                    <li><Link to="/blog">Latest Posts</Link></li>
                    <li><Link to="/events">Events</Link></li>
                  </ul>
                </li>

                <li>
                  <Link to="/contact" className={`btn-nav ${location.pathname === '/contact' ? 'active' : ''}`}>
                    Contact Us
                  </Link>
                </li>
              </ul>
            </div>

            <button className="menu-toggle" onClick={toggleMenu}>
              {isOpen ? <FaTimes /> : <FaBars />}
            </button>
          </div>
        </div>
      </nav>
    </>
  );
};

export default Navbar;
